import React from 'react';
import './footer.css';

const Footer = () => {
    return (
        <div className="footer-class">
            <div className="w-100 p-2 d-none d-md-block bottom-fix" >
                <div className="d-flex flex-row justify-content-between" style={{ margin: '0 5rem', alignItems: 'center' }}>
                    <p>Copyright (c) 2019 Nidharshana Technologies</p>
                    <p>Developed by : <a href="https://pacewisdom.com/" target="_blank" className="text-white">PACEWISDOM</a></p>
                </div>
            </div>
            <div className="w-100 p-2 d-md-none">
                <div className="d-flex justify-content-between text-center">
                    <div className="">
                        <p>Copyright 2016 Arpitha Associates Pvt. Ltd</p>
                    </div>
                    <div className="">
                        <p>Developed by : <span>PACEWISDOM</span></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer; 


// WEBPACK FOOTER //
// ./src/_components/common/Footer/index.jsx